<template>
    <v-container>
        <v-layout wrap>
            <v-flex xs12>
                <w-main-title title="Agendar Hora" :breadcrumbs="breadcrumbs"></w-main-title>
            </v-flex>
            <v-flex v-if="loading" xs12 text-center>
                <v-sheet height="150" class="pt-4">
                    <v-progress-circular indeterminate size="80" width="1" color="accent">
                        Espere...
                    </v-progress-circular>
                </v-sheet>
            </v-flex>
            <appointment-steps v-else :provider="$route.params.providerId" :internal="false" height="360px"/>
        </v-layout>
    </v-container>
</template>

<script>

    import AppointmentSteps from '@/components/appointments/AppointmentSteps.vue'
    import WMainTitle from '@/components/common/WMainTitle.vue'

    import {ApiUtils} from '@/utils/ApiUtils'

    export default {
        name: 'Appointment',
        components: { AppointmentSteps, WMainTitle },
        data(){
            return {
                term: '',
                schedules: [],
                loading: false,
                breadcrumbs: [
                    {
                        text: 'Proveedor',
                        disabled: false,
                        to: {
                            path: `/providers/${this.$route.params.providerId}/profile`
                        }
                    },
                    {
                        text: 'Agendar Hora',
                        disabled: true,
                        href: ''
                    },
                ]
            }
        },
        mounted(){},
        methods: {
            async getSchedules(){

                var vm = this

                vm.loading = true
                var response = await ApiUtils.makeGet(`public/provider/${vm.$route.params.providerId}/schedules`, {
                    term: vm.term
                })
                vm.loading = false

                if (!response.ok) {
                    const json = await
                            response.json()
                    vm.showSnackBar(json.message || 'Ha ocurrido un error intentando consultar agendas')
                    return
                }

                const json = await
                        response.json()
                vm.schedules = json.result.schedules.data

            }
        },
        computed:{
        }
    }
</script>
